export default {
   "type": "object",
   "required": [
      "membertype"
   ],
   "properties": {
      "membertype": {
         "type": "string",
         "title": "Select a membership category",
         "default": "",
         "oneOf": [
            {
               "const": "ASC",
               "title": "Associate Member",
            },
            {
               "const": "STU",
               "title": "Student Member",
            },
            {
               "const": "GRA",
               "title": "Graduate Member",
            },
            {
               "const": "COR",
               "title": "Corporate Member",
            },
            // {
            //    "const": "FEL",
            //    "title": "Fellow Member",
            // },
            // {
            //    "const": "HON",
            //    "title": "Honorary Member",
            // },
            {
               "const": "PAT",
               "title": "Patron",
            },
         ]
      }
   }
}
